// extracted by mini-css-extract-plugin
export default {"templateIndex":"BadgeTemplateIndex_templateIndex__hvKRO","templateLink":"BadgeTemplateIndex_templateLink__3HWf2","noTemplates":"BadgeTemplateIndex_noTemplates__d7k2I"};